export const PDF_PREVIEW_MESSAGE_TYPE = 'CMS_PDF_PREVIEW';
export const PDF_PREVIEW_READY = 'CMS_PDF_PREVIEW_READY';
export const PDF_PREVIEW_ERROR = 'CMS_PDF_PREVIEW_ERROR';

const pendingPdfPayloads = new Map();
let previewIdCounter = 0;
let previewListenerInstalled = false;

const getPublicBasePath = () => {
    const publicUrl = process.env.PUBLIC_URL || '';
    if (!publicUrl) {
        return '';
    }
    return publicUrl.endsWith('/') ? publicUrl.slice(0, -1) : publicUrl;
};

const getPreviewPageUrl = (previewId) => {
    // S3 정적 호스팅에서는 React 라우트(/pdf-preview)가 AccessDenied 될 수 있어
    // 실제 파일 경로인 /pdf-preview/index.html 을 연다.
    const base = getPublicBasePath();
    const url = new URL(`${base}/pdf-preview/index.html`, window.location.origin);
    url.searchParams.set('id', previewId);
    return url.toString();
};

const toPdfBuffer = (pdfBytes) => pdfBytes.buffer.slice(
    pdfBytes.byteOffset,
    pdfBytes.byteOffset + pdfBytes.byteLength
);

const postPdfPayload = (targetWindow, previewId, pdfBytes, fileName) => {
    if (!targetWindow || targetWindow.closed) {
        return false;
    }

    targetWindow.postMessage({
        type: PDF_PREVIEW_MESSAGE_TYPE,
        previewId,
        pdfBytes: toPdfBuffer(pdfBytes),
        fileName,
    }, window.location.origin);

    return true;
};

const installPreviewReadyListener = () => {
    if (previewListenerInstalled || typeof window === 'undefined') {
        return;
    }

    previewListenerInstalled = true;
    window.addEventListener('message', (event) => {
        if (event.origin !== window.location.origin) return;
        if (event.data?.type !== PDF_PREVIEW_READY) return;

        const { previewId } = event.data;
        const payload = pendingPdfPayloads.get(previewId);
        if (!payload || !event.source) {
            return;
        }

        postPdfPayload(event.source, previewId, payload.pdfBytes, payload.fileName);
        pendingPdfPayloads.delete(previewId);
    });
};

installPreviewReadyListener();

/**
 * 클릭 직후(동기) 호출해 PDF 미리보기용 탭을 연다.
 */
export const createPdfPreviewTab = () => {
    const previewId = `cms-pdf-${Date.now()}-${++previewIdCounter}`;
    const previewWindow = window.open(getPreviewPageUrl(previewId), '_blank');

    if (!previewWindow) {
        return null;
    }

    previewWindow.__cmsPreviewId = previewId;
    return previewWindow;
};

/**
 * 미리 열어둔 탭에서 PDF를 브라우저 내장 뷰어로 표시
 */
export const showPdfInPreviewTab = (previewWindow, pdfBytes, fileName = 'document.pdf') => {
    if (!previewWindow || previewWindow.closed) {
        return false;
    }

    const previewId = previewWindow.__cmsPreviewId;
    if (!previewId) {
        return false;
    }

    pendingPdfPayloads.set(previewId, {
        pdfBytes: new Uint8Array(pdfBytes),
        fileName,
    });

    return postPdfPayload(previewWindow, previewId, pdfBytes, fileName);
};

/**
 * 미리보기 탭에 오류 메시지 표시
 */
export const showPdfPreviewError = (previewWindow, message) => {
    if (!previewWindow || previewWindow.closed) {
        return;
    }

    const previewId = previewWindow.__cmsPreviewId;
    if (!previewId) {
        return;
    }

    pendingPdfPayloads.delete(previewId);
    previewWindow.postMessage({
        type: PDF_PREVIEW_ERROR,
        previewId,
        message: message || 'PDF 생성 중 오류가 발생했습니다.',
    }, window.location.origin);
};
